import { FormikError } from '@nv/basic-components'
import clsx from 'clsx'
import fr from 'date-fns/locale/fr'
import { registerLocale } from 'react-datepicker'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useTranslation } from 'react-i18next'
import styles from './DatePicker.module.scss'

registerLocale('fr', fr)

export const DatePicker = ({ field, label, formik, isRequired, ...props }: any) => {
  const { t } = useTranslation()

  return (
    <div className={styles['date-picker']}>
      {label && (
        <label htmlFor={field} className={clsx(styles['label'], isRequired && styles['required'])}>
          {label}
        </label>
      )}
      <ReactDatePicker
        selected={formik.values[field]}
        onChange={(date) => formik.setFieldValue(field, date)}
        className={props.className}
        locale={props.locale}
        maxDate={props.maxDate}
        placeholderText={'Select Date'}
        showTimeSelect
        dateFormat='Pp'
        {...props}
      />
      <FormikError formik={formik} fieldName={field} />
    </div>
  )
}
